{
  "uploadFile": "Datei hochladen",
  "working": "Wird bearbeitet",
  "thinking": "Denkt nach",
  "newChat": "Neuer Chat",
  "recentChats": "Letzte Chats",
  "recents": "Zuletzt",
  "chats": "Chats",
  "chat": "Chat",
  "files": "Dateien",
  "agents": "Agents",
  "messages_one": "{{count}} Nachricht",
  "messages_other": "{{count}} Nachrichten",
  "clickToRename": "Zum Umbenennen klicken",
  "deleteChat": "Chat löschen",
  "archive": "Archivieren",
  "unarchive": "Aus Archiv wiederherstellen",
  "archived": "Archiviert",
  "welcomeTitle": "Willkommen bei Agion Assistants",
  "welcomeSubtitle": "Starten Sie eine Unterhaltung mit dem Agion Assistant oder wählen Sie einen bestimmten Agent",
  "missionWelcomeTitle": "Mission-Chat",
  "missionWelcomeSubtitle": "Starten Sie eine Unterhaltung mit dem Mission-Team. Alle Teilnehmer können Nachrichten sehen und darauf antworten.",
  "agentWelcomeTitle": "Agent-Chat",
  "agentWelcomeSubtitle": "Starten Sie eine Unterhaltung mit diesem Agent. Der Agent unterstützt Sie entsprechend seinen Fähigkeiten und seiner Vertrauensstufe.",
  "agionAssistants": "Agion Assistants",
  "noAgentAccess": "Kein Agent-Zugriff",
  "noAgentAccessDesc": "Sie haben derzeit keinen Zugriff auf Agents. Bitte kontaktieren Sie Ihren Administrator.",
  "connecting": "Verbindung zu Echtzeit-Updates wird hergestellt...",
  "reconnecting": "Verbindung wird wiederhergestellt... (Versuch {{attempt}})",
  "disconnected": "Echtzeit-Updates unterbrochen",
  "connectionError": "Verbindungsfehler — erneuter Versuch...",
  "cancelled": "Anfrage vom Benutzer abgebrochen",
  "processingError": "Entschuldigung, bei der Verarbeitung Ihrer Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
  "typeToMention": "@ eingeben, um Dateien oder Agents zu erwähnen...",
  "referencedFiles": "Referenzierte Dateien ({{count}}):",
  "attachedFiles": "Angehängte Dateien ({{count}}):",
  "all": "Alle",
  "filesCount": "Dateien ({{count}})",
  "agentsCount": "Agents ({{count}})",
  "noFilesOrAgents": "Keine Dateien oder Agents verfügbar",
  "uploadFilesPrompt": "Dateien hochladen oder warten, bis Agents geladen sind...",
  "noFilesFound": "Keine Dateien gefunden",
  "noAgentsFound": "Keine Agents gefunden",
  "sendHint": "Enter zum Senden, Umschalt+Enter für neue Zeile",
  "mentionHint": "@ eingeben, um Dateien oder Agents zu referenzieren",
  "attachHint": "Büroklammer klicken, um Dateien anzuhängen",
  "attachFile": "Datei anhängen",
  "uploadingToStorage": "Wird in den Speicher hochgeladen...",
  "processing": "Wird verarbeitet...",
  "navigateHint": "↑ ↓ zum Navigieren",
  "selectHint": "↵ zum Auswählen",
  "dismissHint": "Esc zum Schließen",
  "you": "Sie",
  "assistant": "Assistant",
  "generatedChart": "Generiertes Diagramm",
  "signOut": "Abmelden",
  "aiAgent": "KI-Agent",
  "noDescription": "Keine Beschreibung verfügbar",
  "howCanIHelp": "Wie kann ich Ihnen heute helfen?",
  "addContent": "Inhalt hinzufügen",
  "mentionFile": "Datei erwähnen",
  "settings": "Einstellungen",
  "history": "Verlauf",
  "autoSelect": "Automatisch",
  "noResults": "Keine Ergebnisse gefunden",
  "rename": "Umbenennen",
  "delete": "Löschen",
  "copy": "In Zwischenablage kopieren",
  "copied": "Kopiert!",
  "regenerate": "Neu generieren",
  "processedIn": "Verarbeitet in {{time}} s",
  "maxFilesReached": "Maximal {{max}} Dateien erlaubt",
  "tasks": "Aufgaben",
  "tasksCount": "{{count}} Aufgaben",
  "searchChats": "Chats suchen...",
  "noChatsFound": "Keine Chats gefunden",
  "participants": "Teilnehmer",
  "external": "extern",
  "showingAs": "Angezeigt als",
  "internalNote": "Interne Notiz",
  "internal": "Notiz",
  "reply": "Antworten",
  "replyToCustomer": "Dem Kunden antworten",
  "missionAccessDenied": "Sie haben keinen Zugriff auf diese Mission. Möglicherweise wurden Sie als Teilnehmer entfernt.",
  "missionAccessDeniedMessage": "Zugriff verweigert. Sie sind kein Teilnehmer dieser Mission.",
  "voiceInput": "Spracheingabe",
  "stopRecording": "Aufnahme beenden",
  "recording": "Aufnahme läuft...",
  "transcribing": "Wird transkribiert...",
  "microphoneAccessDenied": "Mikrofonzugriff verweigert",
  "recordingFailed": "Aufnahme fehlgeschlagen",
  "disclaimer": "Agents können Fehler machen. Überprüfen Sie die Ergebnisse stets.",
  "failedToGetResponse": "Antwort konnte nicht abgerufen werden",
  "downloadChart": "Diagramm herunterladen",
  "freePlan": "Kostenloser Plan",
  "unknownMission": "Unbekannte Mission",
  "unnamedMission": "Unbenannte Mission",
  "missions": "Missions",
  "noMissions": "Keine Missions verfügbar",
  "createMissionInAdmin": "Mission im Admin-Panel erstellen",
  "newMission": "Neue Mission",
  "awaitingHumanInput": "Wartet auf menschliche Eingabe",
  "open": "Öffnen",
  "attention": "Achtung",
  "running": "Läuft",
  "recent": "Zuletzt",
  "showHosts": "Server anzeigen",
  "hideHosts": "Server ausblenden",
  "timeAgo": {
    "justNow": "gerade eben",
    "minutesAgo": "vor {{count}} Min.",
    "hoursAgo": "vor {{count}} Std.",
    "daysAgo": "vor {{count}} Tagen"
  },
  "recentRuns": {
    "showAll": "Alle Unterhaltungen anzeigen",
    "showMore": "Weitere Unterhaltungen anzeigen",
    "showFewer": "Weniger anzeigen",
    "loading": "Unterhaltungen werden geladen…",
    "loadError": "Frühere Unterhaltungen konnten nicht geladen werden"
  },
  "missionRunning": "Mission läuft",
  "searchMissions": "Missions suchen...",
  "noMatchingMissions": "Keine passenden Missions",
  "drafts": "Entwürfe",
  "hostOnline": "Server online",
  "hostOffline": "Server offline",
  "hostStatusChecking": "Server-Status wird geprüft...",
  "hostStatusUnknown": "Server-Status unbekannt",
  "hosts": "Server",
  "noHosts": "Keine Server verfügbar",
  "unassigned": "Nicht zugewiesen",
  "hostGroup": "Hostgruppe",
  "selectMission": "Mission auswählen",
  "selectMissionDescription": "Wählen Sie eine Mission aus der Seitenleiste, um mit Ihrem Agent zu chatten.",
  "clickNewChatToStart": "\"Neuer Chat\" klicken, um zu beginnen",
  "landing": {
    "title": "Woran möchten Sie arbeiten?",
    "subtitle": "Wählen Sie aus, wie Sie beginnen möchten",
    "missionChat": "Mission-Chat",
    "missionChatDescription": "Eine Mission ausführen und über den Chat damit interagieren",
    "knowledgeBase": "Wissensdatenbank",
    "knowledgeBaseDescription": "Fragen zum Wissen Ihrer Organisation stellen",
    "chatWithData": "Mit Daten chatten",
    "chatWithDataDescription": "Verbundene Datenquellen per Konversation abfragen",
    "selectAMission": "Mission zum Starten auswählen",
    "noActiveMissions": "Keine aktiven Missions verfügbar",
    "startChat": "Chat starten",
    "autostart": "Mission startet automatisch",
    "searchMissions": "Missions suchen...",
    "recentlyUpdatedMissions": "Kürzlich aktualisierte Missionen",
    "missionListSubtitle": "Ihre Missions",
    "orStartNew": "oder neue Unterhaltung starten",
    "greeting": "Was möchten Sie tun?",
    "inputPlaceholder": "Beschreiben Sie Ihr Anliegen oder laden Sie eine Datei hoch...",
    "hint": "Nachricht eingeben oder Datei ablegen, dann Mission auswählen",
    "removeFile": "Datei entfernen",
    "loadError": "Ihre Missionen konnten nicht geladen werden",
    "noMissionsGuest": "Es wurden noch keine Missionen mit Ihnen geteilt. Bitten Sie die Person, die Sie eingeladen hat, Sie zu einer hinzuzufügen.",
    "noMissionsGuestWithInviter": "Es wurden noch keine Missionen mit Ihnen geteilt. Sobald jemand eine Mission teilt, erscheint sie hier – bitten Sie {{inviter}}, Sie zu einer hinzuzufügen.",
    "noMissionsReader": "Missionen, zu denen Sie hinzugefügt werden, erscheinen hier.",
    "guestOrgContext": "Sie sind bei {{org}}.",
    "guestOrgContextWithInviter": "Sie sind bei {{org}}, eingeladen von {{inviter}}.",
    "guestCapabilities": "Als Gast können Sie die mit Ihnen geteilten Missionen öffnen und ausführen. Sie können keine Missionen erstellen oder andere Personen einladen.",
    "guestHintBody": "Als Gast können Sie die von {{inviter}} mit Ihnen geteilten Missionen öffnen und ausführen. Neue erscheinen automatisch hier.",
    "guestHintBodyNoInviter": "Als Gast können Sie die mit Ihnen geteilten Missionen öffnen und ausführen. Neue erscheinen automatisch hier.",
    "guestHintDismiss": "Schließen",
    "draft": "Entwurf"
  },
  "welcome": {
    "greeting": "Wie kann ich Ihnen heute helfen?",
    "subtitle": "Starten Sie eine Unterhaltung oder wählen Sie einen Vorschlag unten",
    "noMissionsSubtitle": "Noch keine aktiven Missions. Starten Sie eine Unterhaltung oder erstellen Sie eine Mission.",
    "startConversation": "Neue Unterhaltung starten",
    "missionSubtitle": "Senden Sie eine Nachricht, um diese Mission zu beginnen",
    "agentsInMission": "Agents:",
    "startMission": "Mission starten",
    "suggestions": {
      "summarize": "Aktuelle Mission-Ergebnisse zusammenfassen",
      "agents": "Welche Agents sind verfügbar?",
      "mission": "Helfen Sie mir, eine neue Mission zu erstellen",
      "governance": "Governance-Entscheidung erklären"
    },
    "agentSuggestions": {
      "intro": "Erzählen Sie mir von sich",
      "help": "Wobei können Sie mir helfen?"
    }
  },
  "modes": {
    "mission": "Mission",
    "kb": "Wissensdatenbank",
    "data": "Daten"
  },
  "conversationHistory": {
    "title": "Unterhaltungen",
    "noConversations": "Noch keine Unterhaltungen",
    "startNew": "Oben eine neue Unterhaltung starten"
  },
  "trigger": {
    "childMissionLaunched": "Eine neue Mission wurde ausgelöst",
    "continueWith": "Mit {{name}} fortfahren?",
    "openMission": "Mission öffnen",
    "missionTriggered": "Mission ausgelöst"
  },
  "customer": {
    "historyLoadFailed": "Die Unterhaltung konnte nicht vom Edge-Host geladen werden.",
    "historyLoadFailedHint": "Der Lauf hat möglicherweise mehr gesagt, als hier angezeigt wird. Versuchen Sie es gleich noch einmal.",
    "historyHostUnknown": "Der Edge-Host, der diese Mission ausgeführt hat, ist nicht erfasst, daher kann ihre Unterhaltung nicht gefunden werden.",
    "progress": {
      "title": "Fortschritt",
      "stepsCompleted": "{{completed}} von {{total}} Schritten",
      "allComplete": "Alle Schritte abgeschlossen",
      "failed": "Ausführung fehlgeschlagen"
    },
    "missionCompleted": "Mission erfolgreich abgeschlossen",
    "missionStopped": "Ausführung gestoppt",
    "missionFailed": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
    "missionAnswerTimeout": "Die Ausführung wurde beendet, weil keine Antwort rechtzeitig kam. Senden Sie eine Nachricht, um eine neue Ausführung zu starten.",
    "missionToolReportedError": "Das Werkzeug konnte diese Eingabe nicht verwenden: {{reason}}. Prüfen Sie die Eingabe und versuchen Sie es erneut.",
    "missionCriteriaNotMet": "Die Ausführung wurde abgeschlossen, hat aber nicht alle ihre Erfolgskriterien erfüllt. Prüfen Sie die Antwort, bevor Sie sich darauf verlassen.",
    "missionNoResourceEvidence": "Die Ausführung konnte keine Daten aus den verbundenen Systemen abrufen, daher ist die Antwort möglicherweise unvollständig. Bitten Sie Ihren Administrator, die Verbindung zu prüfen, bevor Sie sich auf die Antwort verlassen.",
    "questionExpired": "Diese Frage ist abgelaufen",
    "reconnecting": "Verbindung wird wiederhergestellt...",
    "streamingUnavailable": "Echtzeit-Updates sind vorübergehend nicht verfügbar. Sie können weiterhin Ihren Unterhaltungsverlauf durchsuchen.",
    "typeMessage": "Nachricht eingeben...",
    "typeToRestart": "Nachricht eingeben, um einen neuen Durchlauf zu starten...",
    "newRunDivider": "Neuer Lauf gestartet. Frühere Nachrichten werden zur Referenz angezeigt.",
    "respondToQuestion": "Antwort eingeben...",
    "waitingForMission": "Warte auf Mission-Antwort...",
    "stop": "Stoppen",
    "stopMission": "Mission stoppen",
    "pause": "Pausieren",
    "pauseMission": "Mission pausieren",
    "resume": "Fortsetzen",
    "resumeMission": "Mission fortsetzen",
    "historyHostOfflineNamed": "{{name}}, der Edge-Host mit dieser Unterhaltung, ist offline. Versuchen Sie es erneut, wenn er wieder erreichbar ist.",
    "historyHostOffline": "Der Edge-Host mit dieser Unterhaltung ist offline. Versuchen Sie es erneut, wenn er wieder erreichbar ist.",
    "runHostMoved": "Dieser Lauf wurde auf einem anderen Edge-Host gestartet, weil der Host mit der bisherigen Unterhaltung nicht verfügbar ist. Dateien aus früheren Nachrichten stehen diesem Lauf nicht zur Verfügung.",
    "conversationOwnedByOther": "Diese Unterhaltung gehört einer anderen Person. Nur diese Person kann sie hier lesen.",
    "conversationStartedAutomatically": "Diese Unterhaltung wurde von einem Zeitplan oder einem Auslöser gestartet, nicht von einer Person. Ihr Inhalt lässt sich nur über die Audit-Seite öffnen."
  },
  "kb": {
    "title": "Wissensdatenbank",
    "placeholder": "Frage stellen...",
    "thinking": "Wissensdatenbank wird durchsucht...",
    "noSources": "Keine Quellen gefunden",
    "sources": "Quellen",
    "fromOrg": "Organisation",
    "fromMission": "Mission",
    "askFollowUp": "Folgefrage stellen..."
  },
  "data": {
    "title": "Mit Daten chatten",
    "selectResources": "Datenquellen auswählen",
    "selectSources": "Datenquellen zum Abfragen auswählen",
    "noResources": "Keine Datenquellen verfügbar",
    "noSources": "Keine Datenquellen verfügbar",
    "sourcesSelected": "Quellen ausgewählt",
    "askPrompt": "Stellen Sie eine Frage zu Ihren Datenquellen",
    "selected": "ausgewählt",
    "startChat": "Chat starten",
    "placeholder": "Fragen Sie zu Ihren Daten...",
    "querying": "Datenquellen werden abgefragt..."
  },
  "governance": {
    "prefix": "Governance",
    "allowed": "Governance: Erlaubt",
    "denied": "Verweigert",
    "obfuscated": "Verschleiert",
    "escalated": "Eskaliert"
  },
  "trust": {
    "tooltip": {
      "tier0": "Eingeschränkt — Dieser Agent arbeitet unter maximaler Aufsicht. Alle Aktionen erfordern eine Genehmigung.",
      "tier1": "Begrenzt — Dieser Agent kann grundlegende Aufgaben ausführen, stoppt jedoch bei wichtigen Entscheidungen.",
      "tier2": "Standard — Dieser Agent erledigt Routineaufgaben und stoppt bei wesentlichen Entscheidungen.",
      "tier3": "Erweitert — Dieser Agent verfügt über erweiterte Berechtigungen und handelt mit minimalen Unterbrechungen."
    }
  },
  "executionLog": {
    "title": "Aktivität",
    "openPanel": "Aktivität öffnen",
    "closePanel": "Aktivität schließen",
    "waitingForEvents": "Warte auf Ereignisse...",
    "noEventsYet": "Noch keine Ereignisse",
    "contentOnHost": "Inhalt auf dem Edge-Host gespeichert",
    "mission": "Mission",
    "rankingDegraded": "Ranking beeinträchtigt",
    "noConfidentMatch": "Kein sicherer Treffer",
    "warningCount": "{{count}} Warnung",
    "warningCount_other": "{{count}} Warnungen",
    "forced": {
      "label": "Vorzeitig beendet",
      "budget": "Vorzeitig beendet: keine Runden mehr übrig. Das Ergebnis ist möglicherweise unvollständig. Grenzen Sie die Aufgabe des Schritts ein oder teilen Sie ihn auf.",
      "stuckRepeating": "Vorzeitig beendet: derselbe Aufruf wurde wiederholt. Das Ergebnis ist möglicherweise unvollständig. Ändern Sie die Anweisungen des Schritts.",
      "repeatedFailure": "Vorzeitig beendet nach wiederholten Werkzeugfehlern. Das Ergebnis ist möglicherweise unvollständig. Prüfen Sie die Verbindung, die der Schritt verwendet.",
      "schemaChurn": "Vorzeitig beendet: Die Struktur der Quelldaten hat sich ständig geändert. Das Ergebnis ist möglicherweise unvollständig. Prüfen Sie das Quellschema."
    }
  },
  "missionChat": {
    "editInDesigner": "Im Designer bearbeiten"
  },
  "workflow": {
    "status": "Workflow: {{status}}",
    "pause": "Pausieren",
    "resume": "Fortsetzen",
    "cancel": "Abbrechen",
    "approve": "Genehmigen",
    "reject": "Ablehnen",
    "progress": "{{completed}} von {{total}} Schritten abgeschlossen",
    "currentStep": "Läuft: {{step}}{{agent}}",
    "turn": "Runde {{current}}/{{max}}",
    "turnProgress": "Runde {{current}} von {{max}}",
    "duration": "Dauer: {{duration}}",
    "waitingApproval": "{{count}} Schritt(e) warten auf Genehmigung",
    "noSteps": "Keine Workflow-Schritte definiert",
    "dependsOn": "Abhängig von",
    "viewDetails": "Workflow-Details anzeigen",
    "event": {
      "started": "Workflow gestartet",
      "startedDescription": "{{steps}} Schritte werden ausgeführt",
      "paused": "Workflow pausiert",
      "pausedDescription": "Workflow wurde pausiert",
      "resumed": "Workflow fortgesetzt",
      "resumedDescription": "Workflow-Ausführung fortgesetzt",
      "completed": "Workflow abgeschlossen",
      "completedDescription": "{{steps}} Schritte in {{duration}} abgeschlossen",
      "failed": "Workflow fehlgeschlagen",
      "cancelled": "Workflow abgebrochen",
      "cancelledDescription": "Workflow-Ausführung wurde abgebrochen",
      "stepStarted": "Schritt gestartet: {{step}}",
      "stepStartedAgent": "Agent {{agent}} wird ausgeführt",
      "stepStartedDescription": "Schrittausführung gestartet",
      "stepProgress": "Schrittfortschritt: {{step}}",
      "stepProgressDescription": "Runde {{current}} von {{max}}",
      "stepCompleted": "Schritt abgeschlossen: {{step}}",
      "stepCompletedDescription": "Abgeschlossen in {{duration}}",
      "stepFailed": "Schritt fehlgeschlagen: {{step}}",
      "stepWaitingApproval": "Genehmigung erforderlich: {{step}}",
      "unknown": "Workflow-Ereignis"
    },
    "command": {
      "statusHelp": "Workflow-Status anzeigen",
      "pauseHelp": "Laufenden Workflow pausieren",
      "resumeHelp": "Pausierten Workflow fortsetzen",
      "cancelHelp": "Laufenden Workflow abbrechen",
      "approveHelp": "Ausstehenden Schritt genehmigen",
      "rejectHelp": "Ausstehenden Schritt ablehnen"
    }
  },
  "outputFile": {
    "download": "Herunterladen",
    "downloading": "Wird heruntergeladen…",
    "downloadFailed": "Download fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "noHost": "Dateien dieses Assistenten können hier noch nicht heruntergeladen werden.",
    "noLongerAvailable": "Diese Datei ist nicht mehr verfügbar. Bitten Sie den Assistenten, sie erneut zu erstellen.",
    "noAccess": "Sie haben keinen Zugriff auf diese Datei.",
    "hostOffline": "Der Server, auf dem diese Datei liegt, ist offline. Versuchen Sie es erneut, sobald er verbunden ist."
  },
  "delivery": {
    "waiting": "Warten, bis die Dateien hochgeladen sind…",
    "sending": "Wird gesendet…",
    "queued": "In der Warteschlange: Der Assistent liest die Nachricht nach seinem aktuellen Schritt.",
    "delivered": "Zugestellt",
    "notConnected": "Nicht gesendet: Die Verbindung zum Assistenten ist unterbrochen.",
    "noReceipt": "Nicht bestätigt: Es kam keine Empfangsbestätigung, der Assistent hat die Nachricht möglicherweise nicht erhalten.",
    "notStarted": "Nicht gesendet: Die Unterhaltung konnte nicht gestartet werden.",
    "notAccepted": "Der Server hat die Nachricht nicht bestätigt. Versuchen Sie es erneut. Wenn es weiterhin fehlschlägt, ist der Server möglicherweise offline oder muss aktualisiert werden.",
    "undelivered": "Nicht zugestellt: Der Lauf endete, bevor der Assistent die Nachricht gelesen hat.",
    "unconfirmed": "Zustellung nicht bestätigt: Der Host konnte nicht bestätigen, dass er diese Antwort erhalten hat.",
    "refused": "Nicht zugestellt.",
    "backInComposer": "Die Nachricht steht wieder im Eingabefeld, damit Sie sie erneut senden können.",
    "chooseAgain": "Wählen Sie Ihre Antwort erneut."
  },
  "receiptReason": {
    "invalidMessage": "Die Nachricht konnte nicht gelesen werden.",
    "notSubscribed": "Dieser Chat folgt dem Lauf nicht mehr. Laden Sie die Seite neu und versuchen Sie es erneut.",
    "senderNotAllowed": "Nur die Person, die diesen Lauf gestartet hat, kann ihm Nachrichten senden.",
    "runNotLive": "Der Lauf ist nicht mehr aktiv.",
    "hostNotConnected": "Der Host, auf dem der Assistent läuft, ist nicht verbunden.",
    "runnerNotConnected": "Der Host, auf dem der Assistent läuft, ist verbunden, sein Runner aber nicht.",
    "messageTooLarge": "Die Nachricht ist zu groß zum Senden.",
    "channelFull": "Die Verbindung zum Assistenten ist ausgelastet. Versuchen Sie es gleich noch einmal.",
    "inboxFull": "Beim Assistenten warten bereits mehrere Nachrichten. Senden Sie diese, nachdem er sie gelesen hat.",
    "modeDoesNotAccept": "Dieser Lauf nimmt keine Nachrichten an, während er arbeitet.",
    "duplicate": "Der Assistent hat diese Nachricht bereits.",
    "unknownMessageType": "Der Server hat die Nachricht nicht erkannt; er muss möglicherweise aktualisiert werden.",
    "runEndedBeforeDelivery": "Der Lauf endete, bevor der Assistent die Nachricht gelesen hat.",
    "attachmentInvalid": "Die angehängten Dateien konnten nicht überprüft werden. Entfernen Sie sie und hängen Sie sie erneut an.",
    "attachmentHostMismatch": "Diese Dateien wurden auf einen anderen Server hochgeladen. Hängen Sie sie auf dem Server dieses Laufs an.",
    "attachmentHostAmbiguous": "Der Server mit diesen Dateien konnte nicht überprüft werden. Hängen Sie die Dateien erneut an.",
    "attachmentTooMany": "Diese Nachricht enthält zu viele Dateien. Entfernen Sie einige Dateien und versuchen Sie es erneut.",
    "attachmentUnavailable": "Die angehängten Dateien sind nicht verfügbar. Versuchen Sie es erneut oder entfernen Sie die Anhänge und hängen Sie die Dateien erneut an."
  },
  "questionAnswerReason": {
    "answerInProgress": "Eine andere Antwort auf diese Frage wird noch geprüft. Warten Sie einen Moment und versuchen Sie es erneut.",
    "answerAdmissionUnavailable": "Der Host konnte die Antwort nicht rechtzeitig annehmen. Versuchen Sie es erneut.",
    "invalidAnswer": "Die Antwort konnte nicht gelesen werden. Prüfen Sie sie und versuchen Sie es erneut.",
    "attemptConflict": "Diese Antwort weicht von der früheren Sendung ab, die sie wiederholt. Senden Sie sie erneut.",
    "questionClosed": "Diese Frage ist nicht mehr offen.",
    "confirmationUnavailable": "Der Host kann nicht mehr bestätigen, ob er diese Antwort erhalten hat.",
    "senderNotAllowed": "Sie dürfen diese Frage nicht beantworten.",
    "runNotLive": "Der Lauf ist nicht mehr aktiv.",
    "attachmentInvalid": "Die angehängten Dateien konnten nicht überprüft werden. Entfernen Sie sie und hängen Sie sie erneut an.",
    "attachmentHostMismatch": "Diese Dateien wurden auf einen anderen Server hochgeladen. Hängen Sie sie auf dem Server dieses Laufs an.",
    "attachmentHostAmbiguous": "Der Server mit diesen Dateien konnte nicht überprüft werden. Hängen Sie die Dateien erneut an.",
    "attachmentTooMany": "Diese Antwort enthält zu viele Dateien. Entfernen Sie einige Dateien und versuchen Sie es erneut.",
    "attachmentUnavailable": "Die angehängten Dateien sind nicht verfügbar. Versuchen Sie es erneut oder entfernen Sie die Anhänge und hängen Sie die Dateien erneut an."
  },
  "questionClosed": {
    "cancelled": "Diese Frage wurde zurückgezogen.",
    "expired": "Diese Frage ist abgelaufen.",
    "publicationFailed": "Diese Frage konnte nicht angezeigt werden und wurde daher geschlossen.",
    "executionEnded": "Diese Frage wurde geschlossen, als der Lauf endete."
  },
  "composer": {
    "agentWorking": "Der Assistent arbeitet. Sie können antworten, sobald er Ihnen eine Frage stellt.",
    "chooseAnOption": "Antworten Sie mit einer der Auswahlmöglichkeiten oben.",
    "questionClosed": "Diese Frage ist nicht mehr offen.",
    "attachUnavailable": "Dieser Assistent kann keine Dateien empfangen.",
    "attachFindingHost": "Der Server für Ihre Dateien wird gesucht…",
    "attachGroupOffline": "Keiner der Server, auf denen dieser Assistent läuft, ist online, daher kann er gerade keine Dateien annehmen. Versuchen Sie es erneut, sobald einer wieder verfügbar ist.",
    "attachHostNotFound": "Der Server für Ihre Dateien wurde nicht gefunden. Laden Sie die Seite neu, um es erneut zu versuchen.",
    "fileNotUploaded": "Eine Datei wurde nicht hochgeladen. Versuchen Sie es erneut oder entfernen Sie sie, und senden Sie dann.",
    "launchFailed": "Die Unterhaltung konnte nicht gestartet werden.",
    "tooLong": "Diese Nachricht ist zu lang zum Senden. Bitte kürzen Sie sie.",
    "pasteTooLong": "Mit dem Eingefügten wäre die Nachricht zu lang zum Senden, daher wurde es nicht übernommen.",
    "notReadyTool": "Dieser Assistent kann noch nicht starten, weil ein Werkzeug, das er verwendet, nicht bereit ist. Bitten Sie seinen Besitzer, es fertigzustellen.",
    "notReadySetup": "Dieser Assistent kann noch nicht starten, weil seine Einrichtung nicht abgeschlossen ist. Bitten Sie seinen Besitzer, sie abzuschließen."
  },
  "launchRefusal": {
    "defaultModelMissing": {
      "admin": "Ihre Organisation hat kein Standard-Chat-Modell, daher hat dieser Auftrag keinen Agenten, unter dem er laufen kann. Wählen Sie eines in der Admin-Konsole unter Governance > Ressourcen > Modelle.",
      "member": "Ihre Organisation hat kein Standard-Chat-Modell, daher hat dieser Auftrag keinen Agenten, unter dem er laufen kann. Bitten Sie einen Administrator, eines auszuwählen."
    },
    "openModelSettings": "Modelleinstellungen öffnen",
    "grantAccessNotReady": {
      "named": "Die Ausführung wurde nicht gestartet, weil der Zugriff des Agenten dieses Auftrags auf folgende Ressourcen noch nicht eingerichtet ist: {{resources}}. Versuchen Sie es gleich noch einmal. Wenn das Problem weiterhin auftritt, wenden Sie sich an support@agion.ai.",
      "unnamed": "Die Ausführung wurde nicht gestartet, weil der Zugriff des Agenten dieses Auftrags noch nicht eingerichtet ist. Versuchen Sie es gleich noch einmal. Wenn das Problem weiterhin auftritt, wenden Sie sich an support@agion.ai."
    },
    "grantAdminDenied": {
      "named": "Die Ausführung wurde nicht gestartet, weil ein Administrator den Zugriff dieses Agenten auf folgende Ressourcen entfernt hat: {{resources}}. Wenden Sie sich an Ihren Administrator oder an support@agion.ai.",
      "unnamed": "Die Ausführung wurde nicht gestartet, weil ein Administrator den Zugriff dieses Agenten auf eine Ressource dieses Auftrags entfernt hat. Wenden Sie sich an Ihren Administrator oder an support@agion.ai."
    },
    "grantTrustTierTooLow": {
      "named": "Die Ausführung wurde nicht gestartet, weil die Vertrauensstufe dieses Agenten nicht erlaubt, was dieser Auftrag für folgende Ressourcen benötigt: {{resources}}. Wenden Sie sich an Ihren Administrator oder an support@agion.ai.",
      "unnamed": "Die Ausführung wurde nicht gestartet, weil die Vertrauensstufe dieses Agenten nicht erlaubt, was dieser Auftrag für eine Ressource dieses Auftrags benötigt. Wenden Sie sich an Ihren Administrator oder an support@agion.ai."
    }
  },
  "escalations": {
    "title": "Eskalationen",
    "fallbackTitle": "Eskalation",
    "approve": "Genehmigen",
    "deny": "Ablehnen",
    "reasonPlaceholder": "Begründung (optional)",
    "confirmApprove": "Genehmigung bestätigen",
    "confirmDeny": "Ablehnung bestätigen",
    "cancel": "Abbrechen",
    "resolving": "Wird gesendet…",
    "expired": "Abgelaufen",
    "expiredNote": "Nicht mehr bearbeitbar — der Schritt ist vor einer Entscheidung abgelaufen.",
    "missionLabel": "Mission",
    "actionLabel": "Möchte ausführen",
    "ruleLabel": "Regel",
    "traceToggle": "Richtliniendetails",
    "consequence": "Genehmigen führt den Schritt jetzt aus · Ablehnen blockiert ihn",
    "type": {
      "actionApproval": "Genehmigung erforderlich",
      "chatHandoff": "Übergabe angefordert",
      "contentReview": "Inhaltsprüfung",
      "guidance": "Anleitung angefordert",
      "complianceReview": "Compliance-Prüfung",
      "question": "Frage"
    },
    "question": {
      "answerPlaceholder": "Ihre Antwort",
      "submit": "Antwort senden",
      "answerLabel": "Antwort",
      "answeredByLabel": "Beantwortet von",
      "answeredAtLabel": "Beantwortet am",
      "answerKeptWithRun": "Die Antwort bleibt beim Lauf.",
      "unavailable": "Diese Frage kann nicht angezeigt werden.",
      "error": {
        "invalid": "Die Frage akzeptiert diese Antwort nicht.",
        "expired": "Die Frage ist abgelaufen, bevor die Antwort ankam.",
        "alreadyAnswered": "Jemand anderes hat die Frage zuerst beantwortet.",
        "forbidden": "Sie können diese Frage nicht beantworten.",
        "failed": "Die Antwort wurde nicht gesendet. Versuchen Sie es erneut.",
        "ticketMismatch": "Die Antwort passte nicht zu Ihrer Sitzung. Laden Sie die Seite neu und versuchen Sie es erneut.",
        "ticketExpired": "Das Senden der Antwort hat zu lange gedauert. Versuchen Sie es erneut.",
        "runNotLive": "Der Lauf ist beendet und kann die Antwort nicht mehr annehmen.",
        "hostNotConnected": "Der Host, der diese Mission ausführt, ist nicht verbunden. Versuchen Sie es später erneut.",
        "malformed": "Die Antwort konnte nicht gelesen werden. Versuchen Sie es erneut.",
        "unreachable": "Der Lauf war nicht erreichbar. Versuchen Sie es erneut.",
        "unconfirmed": "Der Lauf hat die Antwort, sie ist aber noch nicht erfasst. Prüfen Sie es gleich noch einmal."
      },
      "form": {
        "required": "Pflichtfeld",
        "submitNone": "Ich konnte keines davon ermitteln",
        "answeredFields": "Beantwortete Felder",
        "noneAnswered": "Kein Feld konnte ermittelt werden.",
        "error": {
          "number": "Geben Sie eine Zahl ein.",
          "date": "Geben Sie ein vollständiges Datum ein."
        }
      }
    },
    "evidence": {
      "open": "Nachweis öffnen",
      "hide": "Nachweis ausblenden",
      "opening": "Wird geöffnet…",
      "label": "Nachweis",
      "task": "Aufgabe",
      "context": "Kontext",
      "constraints": "Einschränkungen",
      "error": {
        "unavailable": "Der Nachweis kann nicht geöffnet werden.",
        "tooLarge": "Der Nachweis ist zu groß, um ihn hier zu öffnen.",
        "failed": "Der Nachweis wurde nicht geöffnet. Versuchen Sie es erneut."
      }
    },
    "questionCard": {
      "waiting": "Eine Frage wartet auf jemanden, der sie entscheiden kann.",
      "answered": "Beantwortet",
      "askedBy": "Gefragt von",
      "evidenceTitle": "Was der Spezialist gesehen hat",
      "evidenceUnavailable": "Der Nachweis kann hier nicht angezeigt werden.",
      "evidenceEmpty": "Der Spezialist hat keine Angaben erhalten."
    },
    "header": {
      "questionWaiting": "Eine Frage wartet",
      "unknownMission": "Eine Mission",
      "answerInEscalations": "Unter Eskalationen antworten"
    },
    "reviewReason": {
      "decisionCouldNotChoose": "Das Entscheidungsmodell konnte nicht wählen.",
      "decisionUnavailable": "Das Entscheidungsmodell war nicht verfügbar.",
      "agentUnsure": "Das Modell des Spezialisten war sich nicht sicher.",
      "agentUnavailable": "Das Modell des Spezialisten war nicht verfügbar.",
      "agentModelSkipped": "Die Mission fragt direkt eine Person, wenn das Entscheidungsmodell nicht wählen kann."
    }
  },
  "operatorTakeover": {
    "personMarker": "Person",
    "takeOver": "Übernehmen",
    "takingOver": "Wird übernommen…",
    "heldByYou": "Sie führen dieses Gespräch.",
    "openConversation": "Gespräch öffnen",
    "banner": "Sie antworten dem Kunden in Ihrem eigenen Namen",
    "holdUntil": "Sie führen dieses Gespräch bis {{time}}.",
    "ended": "Sie führen dieses Gespräch nicht mehr.",
    "notHeld": "Sie führen dieses Gespräch nicht.",
    "earlierRunsIncomplete": "Ein Teil des früheren Gesprächs konnte nicht geladen werden.",
    "placeholder": "An den Kunden schreiben",
    "send": "Senden",
    "handBack": "Zurückgeben",
    "handingBack": "Wird zurückgegeben…",
    "handBackFailed": "Das Gespräch wurde nicht zurückgegeben. Versuchen Sie es erneut.",
    "reply": {
      "sending": "Wird gesendet…",
      "accepted": "An den Kunden zugestellt",
      "notSent": "Nicht gesendet: Die Verbindung ist unterbrochen.",
      "refused": "Abgelehnt"
    },
    "refusal": {
      "expired": "Die Anfrage ist abgelaufen, bevor Sie sie übernommen haben.",
      "self": "Sie haben dieses Gespräch selbst begonnen, daher muss es jemand anderes übernehmen.",
      "notPending": "Jemand anderes hat das Gespräch übernommen, oder es ist beendet.",
      "forbidden": "Sie können dieses Gespräch nicht übernehmen.",
      "failed": "Das Gespräch wurde nicht übernommen. Versuchen Sie es erneut."
    },
    "replyRefusal": {
      "malformed": "Die Antwort konnte nicht gelesen werden. Prüfen Sie den Text und senden Sie ihn erneut.",
      "senderNotAllowed": "Melden Sie sich erneut an, um zu antworten.",
      "notSubscribed": "Dieses Gespräch ist hier nicht geöffnet. Laden Sie es neu und antworten Sie erneut.",
      "disabled": "Das Übernehmen von Gesprächen ist ausgeschaltet.",
      "noHold": "Sie führen dieses Gespräch nicht mehr.",
      "notOperator": "Eine andere Person führt dieses Gespräch.",
      "unavailable": "Das Gespräch war nicht erreichbar. Versuchen Sie es erneut.",
      "other": "Die Antwort wurde abgelehnt."
    }
  },
  "notifications": {
    "hitlTitle": "Mission wartet auf Ihre Antwort",
    "governanceTitle": "Governance-Warnung",
    "escalationTitle": "Eskalation wartet auf Entscheidung"
  },
  "delegation": {
    "blocked": {
      "label": "Durch Einrichtung blockiert",
      "message": "{{agent}} konnte die Aufgabe nicht abschließen: {{reason}}.",
      "targetNotBound": "Das System ist nicht mit dieser Mission verbunden",
      "targetNotAuthorized": "Diese Mission ist nicht berechtigt, das System zu verwenden",
      "operationOutsideScope": "Die Operation ist in dieser Mission nicht erlaubt",
      "credentialUnavailable": "Die Verbindung hat keine nutzbaren Zugangsdaten",
      "other": "Die Einrichtung der Mission lässt diese Anfrage nicht zu",
      "hint": "Der Ersteller der Mission oder ein Administrator kann dies ändern."
    }
  },
  "launchInputs": {
    "title": "Startwerte",
    "hint": "Der Lauf startet mit diesen Werten.",
    "enterValue": "Geben Sie einen Wert ein, um den Lauf zu starten.",
    "invalidJson": "Geben Sie gültiges JSON ein, zum Beispiel {\"key\": \"value\"} oder [1, 2].",
    "invalidNumber": "Geben Sie eine Zahl ein.",
    "invalidInteger": "Geben Sie eine ganze Zahl ein.",
    "invalidBoolean": "Geben Sie true oder false ein.",
    "selectFile": "Hochgeladene Datei auswählen",
    "uploadFile": "Datei hochladen",
    "uploadingFile": "Datei wird hochgeladen…",
    "uploadFailed": "Datei konnte nicht hochgeladen werden.",
    "retryUpload": "Upload erneut versuchen",
    "removeFile": "Datei entfernen",
    "completeFile": "Wählen Sie eine vollständig hochgeladene Datei aus.",
    "nextMessageStartsRun": "Ihre nächste Nachricht startet eine neue Ausführung.",
    "changeValues": "Startwerte ändern",
    "hideValues": "Startwerte ausblenden"
  },
  "nextSections": {
    "attention": {
      "title": "Wartet auf Ihre Antwort",
      "awaitingInput": "Wartet auf Ihre Eingabe",
      "policyDecision": "Richtlinienentscheidung",
      "escalate": "Eskalieren"
    },
    "recent": {
      "loadError": "Letzte Unterhaltungen konnten nicht geladen werden",
      "nameNotLoaded": "Missionsname nicht geladen",
      "outcome": {
        "running": "Läuft",
        "completed": "Abgeschlossen",
        "failed": "Fehlgeschlagen",
        "cancelled": "Gestoppt"
      }
    }
  },
  "nextConversation": {
    "agent": "Agent",
    "copy": "Kopieren",
    "helpful": "Hilfreich",
    "notHelpful": "Nicht hilfreich",
    "attach": "Dateien anhängen",
    "voice": "Spracheingabe",
    "send": "Nachricht senden",
    "hint": "Eingabetaste zum Senden · Umschalt+Eingabetaste für neue Zeile",
    "working": "Die Mission läuft",
    "governance": {
      "deny": "Abgelehnt",
      "obfuscate": "Maskiert",
      "escalate": "Eskaliert",
      "audit": "Protokolliert"
    },
    "historyLoadError": "Diese Unterhaltung konnte nicht vom Edge-Host geladen werden",
    "question": {
      "closed": "Diese Frage ist nicht mehr offen.",
      "submit": "Antwort senden",
      "atLeast_one": "Wählen Sie mindestens {{count}} Option aus.",
      "atLeast_other": "Wählen Sie mindestens {{count}} Optionen aus.",
      "otherLabel": "Sonstiges",
      "otherPlaceholder": "Ihre Antwort eingeben"
    },
    "escalation": {
      "approve": "Genehmigen",
      "deny": "Ablehnen",
      "approveConsequence": "Wenn du genehmigst, setzt {{agent}} seinen Lauf fort und führt die angeforderte Aktion aus.",
      "denyConsequence": "Wenn du ablehnst, führt {{agent}} die Aktion nicht aus, und der anfragende Schritt des Laufs schlägt fehl.",
      "reasonLabel": "Begründung",
      "reasonPlaceholder": "Begründung...",
      "reasonRequired": "Eine Begründung ist erforderlich.",
      "confirmApprove": "Genehmigung bestätigen",
      "confirmDeny": "Ablehnung bestätigen",
      "cancel": "Abbrechen",
      "backToRequest": "Zurück"
    }
  },
  "nextActivity": {
    "turn": "Zug",
    "thinking": "Denkt nach",
    "started": "Gestartet",
    "completed": "Abgeschlossen",
    "failed": "Fehlgeschlagen",
    "succeeded": "Erfolgreich",
    "waiting": "Wartet…",
    "humanInput": "Menschliche Eingabe",
    "humanResponse": "Menschliche Antwort",
    "orchestrator": "Orchestrator",
    "delegatedTo": "Delegiert an",
    "error": "Fehler",
    "terminalFailure": "Terminaler Fehler",
    "thinkingRedactedBody": "Die interne Überlegung des Modells wurde ausgeblendet.",
    "model": "Modell",
    "tokens": "Token",
    "duration": "Dauer",
    "depth": "Tiefe",
    "in": "ein",
    "out": "aus",
    "filterAll": "Alle",
    "filterTurns": "Züge",
    "filterTools": "Werkzeuge",
    "filterHitl": "HITL",
    "expand": "Mehr anzeigen",
    "collapse": "Weniger anzeigen",
    "statusRunning": "Mission wird ausgeführt",
    "statusComplete": "Ausführung abgeschlossen",
    "statusPaused": "Pausiert",
    "statusFailed": "Ausführung fehlgeschlagen",
    "steps": "Schritte",
    "costLive": "Bisherige Kosten",
    "costEstimate": "Gesch. Kosten",
    "costUnknown": "Unbekannt",
    "usageNotReported_one": "{{count}} Aufruf, Nutzung nicht gemeldet",
    "usageNotReported_other": "{{count}} Aufrufe, Nutzung nicht gemeldet",
    "costExcludesUnreported_one": "Ohne {{count}} Aufruf, dessen Nutzung nicht gemeldet wurde",
    "costExcludesUnreported_other": "Ohne {{count}} Aufrufe, deren Nutzung nicht gemeldet wurde",
    "checkingModelUse": "Modellnutzung wird geprüft…",
    "tokenSpend": "Token-Verbrauch",
    "awaitingFirstCall": "Warten auf den ersten Modellaufruf",
    "executionLog": "Ausführungsprotokoll",
    "jumpToLatest": "Zum neuesten springen",
    "showBreakdown": "Aufschlüsselung nach Modell anzeigen",
    "hideBreakdown": "Aufschlüsselung nach Modell ausblenden",
    "unnamedStep": "Unbenannter Schritt",
    "runEnding": {
      "tool_result_too_large": "Ein Werkzeug hat zu viele Daten geliefert",
      "host_disconnected": "Der Host hat die Verbindung verloren",
      "idle_timeout": "Der Lauf reagiert nicht mehr",
      "context_window_exhausted": "Die Unterhaltung wurde für das Modell zu lang",
      "llm_deadline": "Das Modell hat nicht rechtzeitig geantwortet",
      "mission_budget_exceeded": "Der Lauf hat sein Budget aufgebraucht",
      "provider_unavailable": "Der Modellanbieter war überlastet oder nicht erreichbar",
      "provider_quota_exhausted": "Das Kontingent des Modellanbieters ist aufgebraucht",
      "model_tool_format_rejected": "Das Modell konnte die Werkzeuge der Mission nicht nutzen",
      "repeated_gate_rejection": "Der Lauf ist wiederholt an derselben Abschlussprüfung gescheitert",
      "criteria_not_met": "Die Antwort hat nicht alle Erfolgskriterien erfüllt",
      "no_successful_resource_evidence": "Aus den verbundenen Systemen kamen keine Daten",
      "timeout": "Ein Aufruf hat zu lange gedauert",
      "permission_denied": "Der Zugriff wurde verweigert",
      "not_found": "Etwas wurde nicht gefunden",
      "rate_limited": "Zu viele Anfragen",
      "network_error": "Ein System war nicht erreichbar",
      "service_unavailable": "Ein System war nicht verfügbar",
      "validation_error": "Eine Anfrage wurde als ungültig abgelehnt",
      "token_limit": "Das Längenlimit des Modells wurde erreicht",
      "internal_error": "Ein unerwarteter Fehler",
      "schema_error": "Eine Antwort hatte eine unerwartete Form",
      "model_output_unfit": "Das Modell lieferte wiederholt Antworten, die nicht angezeigt werden konnten",
      "transport_error": "Die Nachrichten des Laufs konnten nicht weitergegeben werden",
      "tool_blocked": "Agion hat den Aufruf blockiert"
    },
    "statusStarting": "Wird gestartet",
    "statusDone": "Fertig",
    "waitingForAnswer": "Wartet auf Ihre Antwort",
    "noModelUse": "Für diese Ausführung ist keine Modellnutzung erfasst",
    "questionStep": "Frage",
    "messageToYou": "Nachricht an Sie",
    "answerStep": "Antwort",
    "agentStep": "Agent",
    "runStep": "Ausführung",
    "stepId": "Schritt-ID",
    "filterQuestions": "Fragen"
  },
  "header": {
    "search": "Nachrichten durchsuchen",
    "closeSearch": "Suche schließen",
    "metaStarted": "Gestartet {{time}}",
    "metaTrust": "Vertrauen: {{tier}}",
    "metaRuns": "{{count}} Läufe",
    "allRuns": "Alle Läufe",
    "moreActions": "Weitere Aktionen"
  },
  "nextRunStep": {
    "running": "Läuft",
    "waiting": "Läuft nicht",
    "completed": "Abgeschlossen",
    "warning": "Mit Warnung abgeschlossen",
    "failed": "Fehlgeschlagen",
    "moreTools_one": "+{{count}} weiterer",
    "moreTools_other": "+{{count}} weitere",
    "unnamedStep": "Unbenannter Schritt"
  },
  "runEnd": {
    "endedWithCause": "Die Ausführung wurde beendet: {{cause}}.",
    "missing": "Es fehlt: {{items}}.",
    "failed": "Die Ausführung ist fehlgeschlagen.",
    "cause": {
      "agent": "Der Agent konnte die Arbeit nicht abschließen",
      "person": "Es wurde auf eine Person gewartet",
      "environment": "Ein verbundenes System oder ein Dienst funktionierte nicht wie nötig",
      "platform": "Die Plattform hatte ein Problem",
      "missionDesign": "Die Einstellungen oder Grenzen der Mission ließen keine Fortsetzung zu",
      "unknown": "Der Grund wurde nicht erfasst",
      "noAnswer": "Niemand hat rechtzeitig geantwortet"
    },
    "next": {
      "agent": "Formulieren Sie die Aufgabe klarer und starten Sie sie dann erneut.",
      "person": "Starten Sie die Mission erneut, wenn jemand antworten kann.",
      "environment": "Prüfen Sie das verbundene System oder den Dienst und starten Sie die Mission dann erneut.",
      "missionDesign": "Prüfen Sie die Einstellungen und Grenzen der Mission und starten Sie sie dann erneut.",
      "platform": "Starten Sie die Mission erneut. Wenn es wieder passiert, wenden Sie sich an Ihren Administrator.",
      "unknown": "Starten Sie die Mission erneut. Wenn es wieder passiert, wenden Sie sich an Ihren Administrator.",
      "noAnswer": "Starten Sie die Mission erneut, wenn jemand antworten kann."
    },
    "missingItem": {
      "criteria": "alle Erfolgskriterien erfüllt",
      "resourceData": "Daten aus den verbundenen Systemen",
      "personAnswer": "eine Antwort von einer Person",
      "stepOutputs": "die Ergebnisse jedes Schritts",
      "time": "Zeit zum Abschließen",
      "room": "Platz, damit das Modell alles lesen kann"
    },
    "cutNote": {
      "title": "Einige Werte dieses Laufs wurden gekürzt, damit sie in seine Grenzen passen.",
      "kind": {
        "delegationHandoff": "Ergebnisse, die ein Agent an einen anderen übergab, wurden gekürzt oder weggelassen.",
        "taskPromptValue": "Einige frühere Ergebnisse wurden gekürzt, damit sie in das Modell passen.",
        "contextShortened": "Frühere Nachrichten der Unterhaltung wurden gekürzt, damit sie in das Modell passen.",
        "runStateText": "Ergebnisse früherer Ziele und gesammelte Antworten wurden gekürzt.",
        "verdictEvidence": "Der in der Antwortprüfung zitierte Nachweis wurde gekürzt.",
        "hydratedRows": "Ein Schritt erhielt nur die ersten Zeilen einer großen Tabelle.",
        "schemaTables": "Einige Tabellen oder Datasets eines verbundenen Systems fehlten in dem, was dem Modell gezeigt wurde.",
        "runLimitBounded": "Eine in der Mission festgelegte Grenze lag über ihrem Höchstwert, daher nutzte der Lauf den Höchstwert."
      },
      "storage": "Wenn der Arbeitsbereichsspeicher auf dem Host eingeschaltet wird, bleiben die Werte vollständig."
    },
    "code": {
      "CONTEXT_LIMIT": {
        "title": "Der an das Modell gesendete Text war auch nach dem Kürzen zu lang",
        "next": "Kürzen Sie die Eingabe oder teilen Sie die Aufgabe in kleinere Teile auf und starten Sie sie dann erneut."
      },
      "RUN_TIME_LIMIT": {
        "title": "Das Zeitlimit wurde erreicht",
        "next": "Ein Organisationsadministrator kann das Zeitlimit für Läufe in den Einstellungen im von Agion erlaubten Bereich erhöhen, oder die Aufgabe wird eingegrenzt, damit sie schneller fertig wird."
      },
      "SOURCE_READ_INCOMPLETE": {
        "title": "Ein verbundenes System hat vor dem Ende des Lesevorgangs keine Daten mehr gesendet",
        "next": "Prüfen Sie das verbundene System und starten Sie die Mission dann erneut."
      },
      "PROVIDER_QUOTA_EXHAUSTED": {
        "next": "Ein Organisationsadministrator kann das Kontingent beim Modellanbieter erhöhen oder ein anderes Modell wählen."
      }
    },
    "codeLabel": "Code: {{code}}",
    "reason": {
      "hostStoreFull": {
        "title": "Der Ergebnisspeicher des Hosts war mit den Daten noch laufender Läufe voll",
        "next": "Ein Eigentümer oder Administrator der Organisation kann das Größenlimit für gespeicherte Ergebnisse auf der Seite des Hosts prüfen und die Mission danach erneut ausführen."
      }
    }
  }
}
